<app-menu headerCSS="bg-dark mb-0"></app-menu>

<div class="container-fluid">
  <div class="row job-invite-container">
    <div class="col-12 col-md-12 mb-3 mb-md-0">
      <app-view-job [showJobPreviewOnly]="true" [showJobFilters]="false" [showDiscussControls]="true"
      (discussClicked)="onDiscussClicked()"></app-view-job>
    </div>
  </div>
</div>

<app-modal #chatModal [modalConfig]="chatModalConfig">
  <div class="col-12 col-md-12 col-lg-12">
    <div class="chat-container">
      <app-chat
        [jobId]="jobId"
        [employerId]="employerAccountId"
        [candidateId]="candidateAccountId"
        [sender]="'candidate'"
      ></app-chat>
    </div>
  </div>
</app-modal>
